import { FlexComponent } from "typings/flexFramework/FlexComponent";

export const getNameFromFlexComponent = (flexComponent: FlexComponent): string => {
  if (flexComponent.type === "Region") {
    return "region";
  } else if (flexComponent.type === "Module") {
    return flexComponent.name;
  } else {
    // probably a TAB
    return "tab";
  }
};
